import api from '@/apis'
import Vuetify from '@/plugins/vuetify'

export default {
  state: {
    mode: null,
    visibility: false,
    unique_current_id: 0,
    form: {
      device_type: null,
      id: null,
      response_aim: null,
      response_type: null,
      speech: null,
      contents: [],
      custom_content: null,
      is_input_disabled: false,
      is_submit_btn_disable: false,
      media_type: null,
      file: null,
      keyword_list: []
    }
  },
  mutations: {
    //  --------- init dialog ---------
    INIT_COMPOSE_RESPONSE_DIALOG(state, payload) {
      const data = JSON.parse(JSON.stringify(payload))
      const { mode, id = null, response_aim = null, response_type = null, is_input_disabled = false, speech = '', custom_content = '', device_type } = data
      state.mode = mode
      state.form.device_type = device_type
      state.form.id = id
      state.form.response_aim = response_aim
      state.form.response_type = response_type
      state.form.is_input_disabled = is_input_disabled
      state.form.speech = speech
      state.form.custom_content = custom_content ? JSON.stringify(custom_content) : ''

      state.form.contents = []
      // Contents
      if (payload.contents) {
        state.form.contents = data.contents
      } else {
        let contents = [{ placement: 'general', text: [{ value: [], value_str: '' }] }] // Default Message

        // Component Default Format
        const ambassador_template = {
          ask_for_selection: { num_of_column: 1, values: [] },
          give_info: { multimedia: { url: '', size: 3 } }
        }
        const chatbot_template = {
          ask_for_selection: { cards: [{ id: state.unique_current_id, image_url: '', title: '', description: '', buttons: [] }] },
          give_info: [{ placement: 'general', text: [{ value: [''] }] }],
          interactive_builder: [{ text: [{ value: [''] }] }]
        }

        // Ambassador Device
        if (device_type === 'ambassador') {
          if (response_aim === 'ask_for_selection') contents.push({ placement: 'general', buttons: { ...ambassador_template[response_aim] } })
          else if (response_aim === 'give_info' && response_type === 'multimedia') contents.push({ placement: 'general', image: { ...ambassador_template[response_aim][response_type] } })
        }

        // Chatbot Device
        else if (device_type === 'chatbot') {
          if (response_aim === 'ask_for_selection') contents.push({ placement: 'general', cards: chatbot_template[response_aim].cards })
          else if (response_aim === 'give_info') contents = chatbot_template.give_info
          else if (response_aim === 'interactive_builder') contents = chatbot_template.interactive_builder
          state.unique_current_id++
        }

        state.form.contents = contents
      }

      state.visibility = true
    },
    //  --------- reset dialog ---------
    RESET_COMPOSE_RESPONSE_DIALOG(state) {
      state.visibility = false
      setTimeout(() => {
        state.mode = null
        state.form = {
          device_type: null,
          id: null,
          response_aim: null,
          response_type: null,
          speech: null,
          contents: [],
          custom_content: null,
          is_input_disabled: false,
          is_submit_btn_disable: false,
          media_type: null,
          file: null,
          keyword_list: []
        }
        state.unique_current_id = 0
      }, 200)
    },

    // --------- set form general details ---------
    SET_COMPOSE_RESPONSE_DIALOG_FORM_SPEECH(state, payload) {
      state.form.speech = payload
    },
    SET_COMPOSE_RESPONSE_DIALOG_FORM_CONTENTS(state, payload) {
      state.form.contents = payload
    },
    SET_COMPOSE_RESPONSE_DIALOG_FORM_IS_INPUT_DISABLED(state, payload) {
      state.form.is_input_disabled = payload
    },
    SET_COMPOSE_RESPONSE_DIALOG_FORM_IS_SUBMIT_BTN_DISABLE(state, payload) {
      state.form.is_submit_btn_disable = payload
    },
    SET_COMPOSE_RESPONSE_DIALOG_FORM_KEYWORD_LIST(state, payload) {
      state.form.keyword_list = payload
    },
    SET_COMPOSE_RESPONSE_DIALOG_FORM_CUSTOM_CONTENT(state, payload) {
      state.form.custom_content = payload
    },
    SET_COMPOSE_RESPONSE_DIALOG_FORM_DEVICE_TYPE(state, payload) {
      state.form.device_type = payload
    },
    SET_COMPOSE_RESPONSE_DIALOG_FORM_MEDIA_TYPE(state, payload) {
      state.form.media_type = payload
    },
    SET_COMPOSE_RESPONSE_DIALOG_FORM_FILE(state, payload) {
      state.form.file = payload
    },

    // --------- ambassador ---------

    // ambassador - display content - selection buttons
    SET_COMPOSE_RESPONSE_DIALOG_CONTENT_BUTTONS_COLUMN(state, payload) {
      const buttons_index = state.form.contents.findIndex((obj) => obj.buttons)
      const total_btn = state.form.contents[buttons_index].buttons.values.length
      let required_btn = payload - (total_btn % payload)
      if (required_btn === payload) required_btn = 0

      let i = 0
      while (i < required_btn) {
        state.form.contents[buttons_index].buttons.values.push({ text: '', payload: '' })
        i++
      }
      state.form.contents[buttons_index].buttons.num_of_column = payload
    },

    // --------- chatbot ---------
    // Add Card or List Tab
    ADD_COMPOSE_RESPONSE_DIALOG_CHATBOT_CONTENTS(state, component) {
      const component_index = state.form.contents.findIndex((obj) => obj[component])
      let contents = component === 'list' ? state.form.contents[component_index][component].elements : state.form.contents[component_index][component]
      contents.push({ id: state.unique_current_id, image_url: '', title: '', description: '', buttons: [] })
      state.unique_current_id++
    },
    SET_COMPOSE_RESPONSE_DIALOG_UNIQUE_CURRENT_ID(state, payload) {
      state.unique_current_id = payload
    },
    RESET_COMPOSE_RESPONSE_DIALOG_CHATBOT_CONTENTS(state, component) {
      state.form.contents.splice(1, 1)

      const card_content = [{ id: state.unique_current_id, image_url: '', title: '', description: '', buttons: [] }]
      const list_content = [{ id: state.unique_current_id, image_url: '', title: '', description: '', buttons: [] }]
      const button_content = { num_of_column: '1', button_type: 'buttons', values: [] }
      const dropdown_content = { title: '', values: [] }

      if (component === 'list') state.form.contents.push({ placement: 'general', list: { elements: list_content } })
      else if (component === 'cards') state.form.contents.push({ placement: 'general', cards: card_content })
      else if (component === 'buttons') state.form.contents.push({ placement: 'general', buttons: button_content })
      else if (component === 'dropdown') state.form.contents.push({ placement: 'general', dropdown: dropdown_content })

      state.unique_current_id++
    },
    // Button Type Switcher - quick reply or buttons
    SET_COMPOSE_RESPONSE_DIALOG_CONTENTS_BUTTON_TYPE(state, payload) {
      const buttons_index = state.form.contents.findIndex((obj) => obj.buttons)
      state.form.contents[buttons_index].buttons.button_type = payload
    }
  },
  actions: {
    async getButtonTriggerKeywordList({ commit, rootState }) {
      try {
        commit('SET_COMPOSE_RESPONSE_DIALOG_FORM_KEYWORD_LIST', [])

        const language = rootState.questionTopic.language
        const response = await api.getButtonTriggerKeywordList({ language })
        if (response.data.success) {
          commit('SET_COMPOSE_RESPONSE_DIALOG_FORM_KEYWORD_LIST', response.data.data)
        } else throw Error(response.data.message)
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      }
    },
    async addQuestionTopicResponse({ commit, dispatch }, payload) {
      try {
        commit('SET_SNACKBAR', {
          status: true,
          color: 'loading',
          text: Vuetify.locale.t('$vuetify.__SnackBar.adding', Vuetify.locale.t('$vuetify.__General.new') + ' ' + Vuetify.locale.t('$vuetify.__Response.response')),
          loading: true
        })
        commit('SET_COMPOSE_RESPONSE_DIALOG_FORM_IS_SUBMIT_BTN_DISABLE', true)

        const response = await api.addResponse(payload)
        if (response.data.success) {
          commit('SET_SNACKBAR', {
            status: true,
            color: 'success',
            text: Vuetify.locale.t('$vuetify.__SnackBar.add', Vuetify.locale.t('$vuetify.__Response.response')),
            icon: 'check',
            timeout: '2000'
          })
          commit('RESET_COMPOSE_RESPONSE_DIALOG')
          dispatch('fetchQuestionTopicKeywordAndResponse', { intent_id: payload.params.intent_id })
        } else throw Error(response.data.message)
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      } finally {
        commit('SET_COMPOSE_RESPONSE_DIALOG_FORM_IS_SUBMIT_BTN_DISABLE', false)
      }
    },
    async editQuestionTopicResponse({ commit, dispatch }, payload) {
      try {
        commit('SET_SNACKBAR', {
          status: true,
          color: 'loading',
          text: Vuetify.locale.t('$vuetify.__SnackBar.editing', Vuetify.locale.t('$vuetify.__Response.response')),
          loading: true
        })
        commit('SET_COMPOSE_RESPONSE_DIALOG_FORM_IS_SUBMIT_BTN_DISABLE', true)

        const response = await api.updateResponse(payload)
        if (response.data.success) {
          commit('SET_SNACKBAR', {
            status: true,
            color: 'success',
            text: Vuetify.locale.t('$vuetify.__SnackBar.edit', Vuetify.locale.t('$vuetify.__Response.response')),
            icon: 'check',
            timeout: '2000'
          })
          commit('RESET_COMPOSE_RESPONSE_DIALOG')
          dispatch('fetchQuestionTopicKeywordAndResponse', { intent_id: payload.params.intent_id })
        } else throw Error(response.data.message)
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      } finally {
        commit('SET_COMPOSE_RESPONSE_DIALOG_FORM_IS_SUBMIT_BTN_DISABLE', false)
      }
    },

    async uploadImageButtonFile({ commit }, payload) {
      try {
        commit('SET_SNACKBAR', { status: true, color: 'loading', text: Vuetify.locale.t('$vuetify.__SnackBar.uploading', ''), loading: true })
        commit('SET_COMPOSE_RESPONSE_DIALOG_FORM_IS_SUBMIT_BTN_DISABLE', true)

        const response = await api.uploadImageFile(payload)
        if (response.data.success) {
          commit('SET_SNACKBAR', {
            status: true,
            color: 'success',
            text: Vuetify.locale.t('$vuetify.__SnackBar.upload', Vuetify.locale.t('$vuetify.__General.file')),
            icon: 'check',
            timeout: '2000'
          })
        } else throw Error(response.data.message)
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      } finally {
        commit('SET_COMPOSE_RESPONSE_DIALOG_FORM_IS_SUBMIT_BTN_DISABLE', false)
      }
    }
  }
}
